export const DEFAULT_DONATION_PERCENTAGE = 10
export const PAYMENT_FEE_COVERAGE_IN_EUROS = 6

// Same rule as the donation step of the in-app adoption payment: a percentage of the adoption fees, rounded to the euro.
export const getDonationInEuros = (amountInCents: number, donationPercentage: number): number => {
  return Math.round((amountInCents / 100 / 100) * donationPercentage)
}

export const getPaymentFeeContributionInEuros = (donationPercentage: number, coverPaymentFees: boolean): number => {
  return donationPercentage === 0 && coverPaymentFees ? PAYMENT_FEE_COVERAGE_IN_EUROS : 0
}

export const getDonationInCents = (params: {
  amountInCents: number
  donationPercentage: number
  coverPaymentFees: boolean
}): number => {
  const donationInEuros = getDonationInEuros(params.amountInCents, params.donationPercentage)
  const paymentFeeContributionInEuros = getPaymentFeeContributionInEuros(
    params.donationPercentage,
    params.coverPaymentFees
  )

  return (donationInEuros + paymentFeeContributionInEuros) * 100
}

export const formatCentsInEuros = (amountInCents: number): string => {
  const hasCents = amountInCents % 100 !== 0

  return `${(amountInCents / 100).toLocaleString('fr-FR', {
    minimumFractionDigits: hasCents ? 2 : 0,
    maximumFractionDigits: 2,
  })}€`
}
